import { LabMDM } from "../masterdata/models/lab";
import { ReactionPlateQuadrant } from "./reaction-plate-quadrant";
import { OrderDetails } from './order-details';

/**    
  * @author Naveen 
  * @description ReactionPlacementRequest model 
  */
export class ReactionPlacementRetainPositionRequest {

  lab: LabMDM;

  reactionPlateId: string;

  reactionPlateQuadrants: Array<ReactionPlateQuadrant>;

  reactionSetData: Array<ReactionSetData>;

  orderHistory: Array<OrderDetails>;

  productType: string;

  reactionSetIds: Array<string>;

  sampleRefs: Array<string>;

  quadrantId: string;

}

export class ReactionSetData {
  reactionSetId: string;
  reactionSetQuadrant: string;
  reactionSetRunLevel: string;
  reactionSetPosition: string;
  reactionSetOtherQuadrantPosition: string;
  reactionSetBarcode: string;
  reactionSetSalesItemType: string;
  reactionSetRow: number;
  reactionSetColumn: number;
  reactionSetActualRow: number;
  reactionSetActualColumn: number;
  reactionSetSampleName: string;
  reactionSetSampleBarcode: string;
  reactionSetPrimerName: string;
  reactionSetPlaced: boolean;
  reactionSetSampleRef: string;

}